import instance from '../instance';

const getReferenceIdByStaticElement = (staticElement) => {
  const { referenceMap } = instance.driver;
  return referenceMap.getReferenceIdByStaticNode(staticElement);
};

export default getReferenceIdByStaticElement;
